// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"717d3ea5","636":"167a1dab"}[chunkId] + ".chunk.js";
};